import { render, staticRenderFns } from "./RequestInformation.vue?vue&type=template&id=237f09a6&"
import script from "./RequestInformation.vue?vue&type=script&lang=js&"
export * from "./RequestInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports